import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getParameterByName } from '../utility/queryStringHelper';
import withDonate from './guest/WithDonate';
import * as AppActions from '../actions/AppActions';
import _get from 'lodash/get';
import { Row } from '@paypalcorp/pp-react';
import { Button } from '@paypalcorp/pp-react';
import templateData from '../utility/getTemplateData';

const deployEnv = require('environment-paypal');

class CaptureOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      accessToken: '',
      isSubmitted: false,
      backBtnVisible: false,
      responseData: '',
      wTransactionEntry: '',
      requestError: '',
    };
  }

  componentDidMount() {
    this.props.toggleSpinner(true);
    const donateToken = getParameterByName('dtoken');
    const orderToken = getParameterByName('token');
    const payerID = getParameterByName('PayerID');

    this.captureOrder(orderToken, donateToken, payerID);
  }

  captureOrder = (orderToken, donateToken, payerID) => {
    this.props
      .captureOrder(orderToken, donateToken, payerID)
      .then((response) => response.json())
      .then((result) => {
        if (_get(result, 'data.orderData.status') !== 'COMPLETED') {
          this.props.history.push('/donate/error/payment');
          return;
        }

        const isMember = _get(result, 'data.orderData.isMember');
        const confirmationData = _get(result, 'data.confirmationData', {});
        this.handlePaymentSuccess(confirmationData, isMember);
      })
      .catch(() => {
        this.props.history.push('/donate/error/payment');
      });
  };

  handlePaymentSuccess = (response, isMember) => {
    AppActions.updateConfirmation({ confirmation: response });
    this.handleConfirmation(response, isMember);
  };

  handleConfirmation = (response, isMember) => {
    const { token } = templateData;
    const flow = isMember ? 'member' : 'guest';
    const page = response.isOfacPending ? 'pending' : 'confirmation';
    const url = token
      ? `/donate/${flow}/${page}/?token=${token}`
      : `/donate/${flow}/${page}`;

    this.props.history.push(url);
  };

  handleClick = () => {
    this.setState({
      isSubmitted: true,
    });
  };

  renderCaptureButton = () => {
    if (!deployEnv.isLive()) {
      return (
        <Button id="buttonOrder" onClick={this.handleClick}>
          Capture
        </Button>
      );
    }
    return null;
  };

  render() {
    return (
      <div>
        <div className="container">
          <div>
            <div>
              <Row style={{ textAlign: 'center' }}>
                {this.renderCaptureButton()}
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CaptureOrder.propTypes = {
  toggleSpinner: PropTypes.func,
  captureOrder: PropTypes.func,
  history: PropTypes.object,
};

export default withDonate(CaptureOrder);
